import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, DateBox, NumberBox, Popup, SelectBox, TextBox } from 'devextreme-react';
import { inventoryService } from '../services/inventory-service';
import { useNavigate, useParams } from 'react-router-dom';
import { DateBoxTypes } from 'devextreme-react/cjs/date-box';
import { toast } from 'react-toastify';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { NumberBoxTypes } from 'devextreme-react/cjs/number-box';
import { confirm } from 'devextreme/ui/dialog';
import { Width } from 'devextreme-react/cjs/chart';

function InventoryDetail() {

    let dateValue = new Date();
    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    const [productCodeValue, setProductCodeValue] = useState("");
    const [siteCodeValue, setSiteCodeValue] = useState("");

    const params = useParams();
    let siteCode: string | number = "";
    let productCode: string | number = "";
    const onGetOrderData = useCallback(async () => {
        siteCode = params.sitecode != undefined ? params.sitecode : "";
        productCode = params.productcode != undefined ? params.productcode : "";

        setProductCodeValue(productCode)
        setSiteCodeValue(siteCode)

        const x = await inventoryService.getOrderDetailList(siteCode, productCode);
        return x;
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const navigate = useNavigate();
    const goToBack = () => {
        navigate(`/syncflow/inventory-list`)
    }

    const goToAdd = () => {
        showInfoOrders(true);
    }

    const [popupVisibleOrders, setPopupVisibleOrders] = useState(false);
    const showInfoOrders = useCallback((e: any) => {
        setPopupVisibleOrders(true);
    }, [setPopupVisibleOrders]);

    const hideInfoOrders = useCallback(() => {
        setPopupVisibleOrders(false);
    }, [setPopupVisibleOrders]);

    const [paymentTypeLookup] = useState(new CustomStore({
        load: inventoryService.paymentTypeLookup
    }));

    const onValueChangedStartDate = useCallback((e: DateBoxTypes.ValueChangedEvent) => {
        dateValue = e.value;
    }, []);


    const newPayment: any = {};
    const savePayment = () => {
        newPayment.siteCode = siteCodeValue;
        newPayment.productCode = productCodeValue;

        newPayment.quantity = qtyValue;
        newPayment.transactionTypeCode = transactionTypeValue;
        newPayment.transactionDate = dateValue;

        inventoryService.savePayment(newPayment).then((response) => {
            toast.success(t("syncflow:msg_saved"));
            hideInfoOrders();
            dataGridRef.current?.instance.refresh();
        });
    }

    const [transactionTypeValue, setTransactionTypeValue] = useState("");
    const onValueChangedTransactionType = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
        setTransactionTypeValue(e.value);
    }, []);

    const [qtyValue, setQtyValue] = useState(null);
    const onValueChangedQty = useCallback((e: NumberBoxTypes.ValueChangedEvent) => {
        setQtyValue(e.value)
    }, []);


    const deleteFunc = (id: number) => {
        let result = confirm(t("syncflow:msg_delete"), t("syncflow:ti_confirm"));
        result.then((dialogResult) => {
            if (dialogResult) {

                inventoryService.deletePayment(id).then((response) => {
                    toast.success(t("syncflow:msg_saved"));
                    dataGridRef.current?.instance.refresh();
                })
            }
        });
    }

    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_back")}
                        type="default"
                        icon="back"
                        stylingMode="contained"
                        onClick={goToBack}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text="Add"
                        type="default"
                        icon="add"
                        stylingMode="contained"
                        onClick={goToAdd}
                    />
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    columnChooser={true}
                    showColumnLines={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}

                    columns={[
                        {
                            dataField: 'transactionDate',
                            caption: t('syncflow:lb_date'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'date',
                        },
                        {
                            dataField: 'sourceName',
                            caption: t('syncflow:lb_source_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'transactionType',
                            caption: t('syncflow:lb_movement_type'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'direction',
                            caption: t('syncflow:lb_entrance_exit'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: payment_type_render,
                        },
                        {
                            dataField: 'quantity',
                            caption: t('syncflow:lb_qty'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unit',
                            caption: t('syncflow:lb_measurement_unit_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            caption: t('syncflow:lb_order_status'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: status_render                           
                        }, 
                        {
                            allowFiltering: true,
                            allowEditing: false,
                            width:80,
                            cellRender: (data: any) => {
                                return (
                                     data.data.isDeletable && !data.data.isDelete ?
                                        <Button
                                        text=''
                                            type="default"
                                            icon='trash'
                                            onClick={() => deleteFunc(data.key.id)}
                                        />
                                        : null
                                );
                            },
                        },
                    ]}
                />
            </React.Fragment>

            <Popup
                visible={popupVisibleOrders}
                onHiding={hideInfoOrders}
                showCloseButton={true}
                title="Add"
                showTitle={true}
                width={400}
                height={280}
                position={{ of: window, at: 'center', my: 'center' }}
            >

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Date</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <DateBox
                                    name="dueStartDateValue"
                                    defaultValue={dateValue}
                                    type="date"
                                    showClearButton={true}
                                    min={sevenDaysAgo}
                                    onValueChanged={onValueChangedStartDate}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Transaction Type</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <SelectBox
                                    name="paymentTypeLookup"
                                    dataSource={paymentTypeLookup}
                                    onValueChanged={onValueChangedTransactionType}
                                    valueExpr="code"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    showClearButton={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <label className="col-lg-5 col-form-label fw-bold fs-6">Quantity</label>
                    <div className="col-lg-7">
                        <div className="row">
                            <div className="fv-row">
                                <NumberBox
                                    onValueChanged={onValueChangedQty}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <br></br>
                <div className='row mb-4 justify-content-end'>
                    <div className='col-auto'>
                        <Button
                            text={t("syncflow:btn_save")}
                            type="default"
                            stylingMode="contained"
                            icon="check"
                            onClick={savePayment}
                        />
                    </div>
                </div>
            </Popup>
        </>
    )
}
const status_render = (data: any) => (data.row.data.isDelete == true? t('syncflow:btn_cancel') : "");
const payment_type_render = (data: any) => (data.row.data.direction == -1 ? "Out" : "In");
export default InventoryDetail